import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import OchaIcon from './OchaIcon';

const programmes = [
    {
        title: "Women's Empowerment",
        color: "#E91E63",
        bgLight: "#FCE4EC",
        icon: "Gender",
        actions: [
            "Technical support to SHGs",
            "Skills development training",
            "Agro-livelihood support",
            "Entrepreneurship support",
            "Financial literacy training"
        ]
    },
    {
        title: "Water & Sanitation",
        color: "#00ACC1",
        bgLight: "#E0F7FA",
        icon: "Water-Sanitation-and-Hygiene",
        actions: [
            "Watershed development",
            "Water efficiency drives",
            "Village Sanitation planning",
            "JJM training for GPs",
            "School sanitation support"
        ]
    },
    {
        title: "Sustainable Agriculture",
        color: "#43A047",
        bgLight: "#E8F5E9",
        icon: "Agriculture",
        actions: [
            "Composting awareness",
            "Organic farming practices",
            "Crop diversification project",
            "Soil health management",
            "Farm-based livelihoods"
        ]
    },
    {
        title: "Environment Sustainability",
        color: "#2E7D32",
        bgLight: "#E8F5E9",
        icon: "Environment",
        actions: [
            "Social forestry campaigns",
            "Waste management drives",
            "Biodiversity registers",
            "Eco-entrepreneurships",
            "Wildlife conflict mitigation"
        ]
    }
];

const cardVariants = {
    offscreen: { opacity: 0, y: 40 },
    onscreen: {
        opacity: 1,
        y: 0,
        transition: { type: "spring", bounce: 0.3, duration: 0.8 }
    }
};

const PsgsProgrammes = () => {
    return (
        <Container fluid style={{ padding: '40px 20px' }}>
            <h2 className="text-center mb-2" style={{ color: '#2E7D32', fontWeight: 'bold', fontSize: '2rem' }}>
                PSGS Programmes
            </h2>
            <p className="text-center mb-4" style={{ color: '#555', fontSize: '0.95rem' }}>
                20 years of action for change | 3869 villages | 13 districts | 33 major projects
            </p>

            <Row className="justify-content-center gx-3">
                {programmes.map((prog, index) => (
                    <Col xs={12} sm={6} lg={3} key={index} className="mb-4">
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.2 }}
                            variants={cardVariants}
                            style={{ height: '100%' }}
                        >
                            <div style={{
                                border: `2px solid ${prog.color}`,
                                borderRadius: '12px',
                                overflow: 'hidden',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundColor: '#fff',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                            }}>
                                <div style={{
                                    backgroundColor: prog.bgLight,
                                    padding: '18px 15px',
                                    textAlign: 'center',
                                    borderBottom: `2px solid ${prog.color}`
                                }}>
                                    <div style={{
                                        width: '50px',
                                        height: '50px',
                                        backgroundColor: prog.color,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 10px'
                                    }}>
                                        <OchaIcon name={prog.icon} size={28} color="white" />
                                    </div>
                                    <h5 style={{
                                        color: prog.color,
                                        fontWeight: 'bold',
                                        margin: 0,
                                        fontSize: '1.05rem'
                                    }}>
                                        {prog.title}
                                    </h5>
                                </div>

                                <div style={{ padding: '10px 0', flex: 1 }}>
                                    <div style={{
                                        padding: '6px 15px',
                                        backgroundColor: prog.color,
                                        color: '#fff',
                                        fontWeight: '600',
                                        fontSize: '0.85rem',
                                        marginBottom: '6px'
                                    }}>
                                        Key Actions
                                    </div>
                                    {prog.actions.map((action, i) => (
                                        <div key={i} style={{
                                            padding: '8px 15px',
                                            fontSize: '0.9rem',
                                            color: '#333',
                                            borderBottom: i < prog.actions.length - 1 ? '1px solid #f0f0f0' : 'none',
                                            backgroundColor: i % 2 === 0 ? '#fafafa' : '#fff'
                                        }}>
                                            {action}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default PsgsProgrammes;
